import {
    Typography,
    Box,
} from "@mui/material";
import TopBar from "../../components/topBar/TopBar";
import { useEffect, useState } from "react";
import SendRequest from "../../request/SendRequest";
import Loading from "../../components/Loading/loading";
import BillingStatements from "../../components/BillingStatement/BillingStatements";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const BillingStatementsIndex = () => {
    const [loading, setLoading] = useState(true)
    const [billData, setBillData] = useState()
    const [paymentData, setPaymentData] = useState()
    const [userInfoData, setUserInfoData] = useState()

    const [snackBar, setSnackBar] = useState({
        open: false,
        message: '',
        severity: '',
    })
    const handleSnackBarClose = () => {
        setSnackBar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    useEffect(() => {
        fetchContent();
    }, []);


    const fetchContent = async () => {
        const fetchBillData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/billingStatements' }).then(response => {
            if (response.status === 200) {
                setBillData(response.data.data);
            }
        })

        const fetchPaymentData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/paymentTransactions' }).then(response => {
            if (response.status === 200) {
                setPaymentData(response.data.data);
            }
        })

        const fetchUserInfoData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/userInfo' }).then(response => {
            if (response.status === 200) {
                setUserInfoData(response.data.data);
            }
        })

        Promise.all([fetchBillData, fetchPaymentData, fetchUserInfoData]).then(() => {
            setLoading(false)
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoading(false)
        })
    };

    return (
        <>
            <Box textAlign="center">
                <Loading show={loading} />
                <TopBar />
                <Box sx={{ width: 500 }}>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={snackBar.open}
                        autoHideDuration={3000}
                        onClose={handleSnackBarClose}
                    >
                        <Alert
                            onClose={handleSnackBarClose}
                            severity={snackBar.severity}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {snackBar.message}
                        </Alert>
                    </Snackbar>
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={"16px"} padding={{ xs: "24px 8px", sm: "24px 16px", md: "24px 24px" }}>
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} >
                        <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }} padding={"16px 0 16px 0"}>
                            <Typography fontSize={18} fontWeight={700} color={"rgba(67, 71, 78, 1)"} textAlign={"left"}>過去帳單及交易紀錄</Typography>
                        </Box>
                    </Box>
                    {!loading &&
                        <>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} >
                                <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <BillingStatements
                                        billingData={billData}
                                        paymentData={paymentData}
                                        userInfoData={userInfoData}
                                        snackBar={snackBar}
                                        setSnackBar={setSnackBar}
                                    />
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            </Box>
        </>
    )
}

export default BillingStatementsIndex